import { Footer } from '@pets-ui/Footer/Footer'
import { FooterStack } from '@pets-ui/FooterStack/FooterStack'
import { HStack } from '@pets-ui/HStack/HStack'
import { type ReactNode } from 'react'

export interface PageFooterProps {
  actionButton: ReactNode
  detail?: ReactNode
  /** 浮在 sticky bar 上方右側的元件（例如快速下單 FAB） */
  floatingAction?: ReactNode
}

export const PageFooter = ({ actionButton, detail, floatingAction }: PageFooterProps) => {
  const renderTransparentFooters = floatingAction
    ? () => (
      <Footer variant="transparent" ContainerProps={{ justifyContent: 'flex-end' }}>
        {floatingAction}
      </Footer>
    )
    : undefined

  return (
    <FooterStack enableContainer renderTransparentFooters={renderTransparentFooters}>
      <Footer>
        <HStack gap={2} width="100%" justifyContent="space-between">
          {detail}
          <HStack justifyContent="flex-end" marginLeft="auto">
            {actionButton}
          </HStack>
        </HStack>
      </Footer>
    </FooterStack>
  )
}
